import { Injectable } from '@angular/core';
import { NotifierService } from 'angular-notifier';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private notifier: NotifierService) {}

  duration = 3000;
  button = 'fechar';

  error(message: string) {
    this.notifier.show({
      type: 'error',
      message,
    });
  }

  info(message: string) {
    this.notifier.show({
      type: 'info',
      message,
    });
  }

  success(message: string) {
    this.notifier.show({
      type: 'success',
      message,
    });
  }
}
